function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.7864531,12.0000469 L23.6301094,2.15639062 C24.123375,1.66307812 24.123375,0.863296875 23.6301094,0.37003125 C23.1367969,-0.12328125 22.3369688,-0.12328125 21.8437031,0.37003125 L12,10.2136875 L2.15634375,0.37003125 C1.66303125,-0.12328125 0.86325,-0.12328125 0.369984375,0.37003125 C-0.12328125,0.86334375 -0.123328125,1.663125 0.369984375,2.15639062 L10.2136406,12.0000469 L0.369984375,21.8437031 C-0.123328125,22.3370156 -0.123328125,23.1367969 0.369984375,23.6300625 C0.863296875,24.123375 1.66307813,24.1233281 2.15634375,23.6300625 L12,13.7864062 L21.8436094,23.6300625 C22.3369219,24.123375 23.13675,24.1233281 23.6300156,23.6300625 C24.1232813,23.13675 24.1232813,22.3369687 23.6300156,21.8437031 L13.7864531,12.0000469 Z"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.79840626.svg";
export { ForwardRef as ReactComponent };